import { inizializeGlider } from './../modules/glider-initalize';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    //Sidebar
    const openSidebar = document.querySelector('.js-open-sidebar'); 
    const closeSidebar = document.querySelector('.js-close-sidebar'); 
    const sidebar = document.querySelector('.js-promo-aside');

    if(openSidebar){

      openSidebar.addEventListener('click', function(){
        sidebar.classList.toggle('is-open');
      });
      
      openSidebar.addEventListener('mouseover', function(){
        openSidebar.classList.add('grow-width');
        
      });

      openSidebar.addEventListener('mouseleave', function(){
        openSidebar.classList.remove('grow-width');
      });
      
    }

    if(closeSidebar){
      closeSidebar.addEventListener('click', function(){
        sidebar.classList.toggle('is-open');
      });
    }

    const filterItems = document.querySelectorAll('.js-filter-item');
    if (filterItems) {
      filterItems.forEach(item => {
        item.querySelector('input').addEventListener('click', () => {
          if (item.classList.contains('is-parent')) {
            let sibling = item.nextElementSibling;
            let subfilters;
            if (sibling) {
              subfilters = sibling.querySelectorAll('.js-filter-item input');
            }
            if (subfilters) {              
              if (item.classList.contains('is-active')) {
                item.classList.remove('is-active');
                subfilters.forEach(element => {
                  element.checked = false;
                });
              } else {
                item.classList.add('is-active');
                subfilters.forEach(element => {
                  element.checked = true;
                });
              }
            }
          } else {
            let subgroup = item.parentNode.querySelectorAll('label.js-filter-item');
            let parentCheck = item.parentNode.parentNode.querySelectorAll('label.is-parent').item(0);
            let siblingsStatus = checkAll(subgroup);

            if (siblingsStatus) {
              parentCheck.classList.add('is-active');
              parentCheck.querySelector('input.FilterItem__Input').checked = true;
            } else {
              parentCheck.classList.remove('is-active');
              parentCheck.querySelector('input.FilterItem__Input').checked = false;
            }
          }
        })
      });
    }

    const checkAll = (list) => {
      let test;
      list.forEach(element => {
        if (element.querySelector('.FilterItem__Input').checked === false) {
          test = false;
        }
      });
      return test === false ? false : true;
    }

    window.currentPage = 1;

    const archiveWrapper = document.querySelector('.ArchivePromo__Wrapper');
    const updateCards = (page) => {
      archiveWrapper.classList.add('js-archive-loading');
      let catIds = [];
        filterCheckbox.forEach(element => {
          let inputCheck = element.querySelector('.FilterItem__Input');
          if (inputCheck.checked) {
            catIds.push(inputCheck.dataset.termid)
          }
        });

        fetch(`${window.location.origin}/primacasa/wp-admin/admin-ajax.php?action=filterpromo&cat_ids=${catIds.join()}&paged=${page}`)
          .then(response => {
          // The API call was successful!
          return response.text();
          }).then( html => {
            // This is the HTML from our response as a text string
            archiveWrapper.classList.remove('js-archive-loading');
            document.querySelector('.js-cards-wrapper').innerHTML = html;
            inizializeGlider();
            window.currentPage = page;
            setArrowListeners();
          }).catch(() => {
            // There was an error

          });
    };

    const filterSubmit = document.querySelector('.js-filter-submit');
    let filterGroup = document.querySelectorAll('.Filters__Group');
    let filterCheckbox = [];
    filterGroup.forEach(element => {
      if (element.querySelector('.js-subfilters')) {
        element.querySelectorAll('.js-filter-item.FilterItem--Subcategory').forEach(element => {
          filterCheckbox.push(element)  
        });
      } else {
        filterCheckbox.push(element.querySelector('.js-filter-item'));
      }
    });

    if (filterSubmit && filterCheckbox) {
      filterSubmit.addEventListener('click', () => {updateCards(1)});
    }

    const setArrowListeners = () => {
      const prevPagination = document.querySelector('.Pagination__Arrow--Prev');
      if(prevPagination){
        document.querySelector('.Pagination__Arrow--Prev').addEventListener('click', (ev) => {
          if(ev.target.classList.contains('is-disabled')){
            return;
          }
          updateCards(window.currentPage - 1);
        });
      }
      const nextPagination = document.querySelector('.Pagination__Arrow--Next');
      if(nextPagination){
        document.querySelector('.Pagination__Arrow--Next').addEventListener('click', (ev) => {
          if(ev.target.classList.contains('is-disabled')){
            return;
          }
          updateCards(window.currentPage + 1);
        });
      }
    };

    setArrowListeners();

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive-promo.js